/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FilterOption,
  ModelOptions,
  ModelOptionsParams,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Models Filters
 */
export const modelFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOption[]>(
      {url: `/filters/models`, method: 'GET', signal
    },
      );
    }




export const getModelFiltersQueryKey = () => {
    return [
    'filters','models'
    ] as const;
    }


export const getModelFiltersQueryOptions = <TData = Awaited<ReturnType<typeof modelFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelFilters>>> = ({ signal }) => modelFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelFilters>>, TError, TData>
}

export type ModelFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof modelFilters>>>
export type ModelFiltersQueryError = ErrorType<unknown>


/**
 * @summary Models Filters
 */

export function useModelFilters<TData = Awaited<ReturnType<typeof modelFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model classifications Filters
 */
export const modelClassificationsFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOption[]>(
      {url: `/filters/models/classifications`, method: 'GET', signal
    },
      );
    }




export const getModelClassificationsFiltersQueryKey = () => {
    return [
    'filters','models','classifications'
    ] as const;
    }


export const getModelClassificationsFiltersQueryOptions = <TData = Awaited<ReturnType<typeof modelClassificationsFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelClassificationsFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelClassificationsFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelClassificationsFilters>>> = ({ signal }) => modelClassificationsFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelClassificationsFilters>>, TError, TData>
}

export type ModelClassificationsFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof modelClassificationsFilters>>>
export type ModelClassificationsFiltersQueryError = ErrorType<unknown>


/**
 * @summary Model classifications Filters
 */

export function useModelClassificationsFilters<TData = Awaited<ReturnType<typeof modelClassificationsFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelClassificationsFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelClassificationsFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Dock Sizes Filters
 */
export const modelDockSizesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOption[]>(
      {url: `/filters/models/dock-sizes`, method: 'GET', signal
    },
      );
    }




export const getModelDockSizesFiltersQueryKey = () => {
    return [
    'filters','models','dock-sizes'
    ] as const;
    }


export const getModelDockSizesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof modelDockSizesFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelDockSizesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelDockSizesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelDockSizesFilters>>> = ({ signal }) => modelDockSizesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelDockSizesFilters>>, TError, TData>
}

export type ModelDockSizesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof modelDockSizesFilters>>>
export type ModelDockSizesFiltersQueryError = ErrorType<unknown>


/**
 * @summary Model Dock Sizes Filters
 */

export function useModelDockSizesFilters<TData = Awaited<ReturnType<typeof modelDockSizesFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelDockSizesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelDockSizesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model focus Filters
 */
export const modelFocusFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOption[]>(
      {url: `/filters/models/focus`, method: 'GET', signal
    },
      );
    }




export const getModelFocusFiltersQueryKey = () => {
    return [
    'filters','models','focus'
    ] as const;
    }


export const getModelFocusFiltersQueryOptions = <TData = Awaited<ReturnType<typeof modelFocusFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelFocusFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelFocusFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelFocusFilters>>> = ({ signal }) => modelFocusFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelFocusFilters>>, TError, TData>
}

export type ModelFocusFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof modelFocusFilters>>>
export type ModelFocusFiltersQueryError = ErrorType<unknown>


/**
 * @summary Model focus Filters
 */

export function useModelFocusFilters<TData = Awaited<ReturnType<typeof modelFocusFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelFocusFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelFocusFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Options
 */
export const modelOptions = (
    params?: MaybeRefOrGetter<ModelOptionsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<ModelOptions>(
      {url: `/filters/models/options`, method: 'GET',
        params, signal
    },
      );
    }




export const getModelOptionsQueryKey = (params?: MaybeRefOrGetter<ModelOptionsParams>,) => {
    return [
    'filters','models','options', ...(params ? [params] : [])
    ] as const;
    }


export const getModelOptionsQueryOptions = <TData = Awaited<ReturnType<typeof modelOptions>>, TError = ErrorType<SchemaValidationErrorResponse>>(params?: MaybeRefOrGetter<ModelOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelOptions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelOptionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelOptions>>> = ({ signal }) => modelOptions(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelOptions>>, TError, TData>
}

export type ModelOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof modelOptions>>>
export type ModelOptionsQueryError = ErrorType<SchemaValidationErrorResponse>


/**
 * @summary Model Options
 */

export function useModelOptions<TData = Awaited<ReturnType<typeof modelOptions>>, TError = ErrorType<SchemaValidationErrorResponse>>(
 params?: MaybeRefOrGetter<ModelOptionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelOptions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelOptionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Production states Filters
 */
export const modelProductionStatesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOption[]>(
      {url: `/filters/models/production-states`, method: 'GET', signal
    },
      );
    }




export const getModelProductionStatesFiltersQueryKey = () => {
    return [
    'filters','models','production-states'
    ] as const;
    }


export const getModelProductionStatesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof modelProductionStatesFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelProductionStatesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelProductionStatesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelProductionStatesFilters>>> = ({ signal }) => modelProductionStatesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelProductionStatesFilters>>, TError, TData>
}

export type ModelProductionStatesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof modelProductionStatesFilters>>>
export type ModelProductionStatesFiltersQueryError = ErrorType<unknown>


/**
 * @summary Model Production states Filters
 */

export function useModelProductionStatesFilters<TData = Awaited<ReturnType<typeof modelProductionStatesFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelProductionStatesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelProductionStatesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Model Sizes Filters
 */
export const modelSizesFilters = (

 signal?: AbortSignal
) => {


      return axiosClient<FilterOption[]>(
      {url: `/filters/models/sizes`, method: 'GET', signal
    },
      );
    }




export const getModelSizesFiltersQueryKey = () => {
    return [
    'filters','models','sizes'
    ] as const;
    }


export const getModelSizesFiltersQueryOptions = <TData = Awaited<ReturnType<typeof modelSizesFilters>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelSizesFilters>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelSizesFiltersQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelSizesFilters>>> = ({ signal }) => modelSizesFilters(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelSizesFilters>>, TError, TData>
}

export type ModelSizesFiltersQueryResult = NonNullable<Awaited<ReturnType<typeof modelSizesFilters>>>
export type ModelSizesFiltersQueryError = ErrorType<unknown>


/**
 * @summary Model Sizes Filters
 */

export function useModelSizesFilters<TData = Awaited<ReturnType<typeof modelSizesFilters>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelSizesFilters>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelSizesFiltersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






